import React from "react";

// No need to import here; instead, do this in gatsby_config.js
// import YAMLData from "../../data/badges.yaml";
//
// Example:
// ---
// title: Code
// description: Code overview.
// badges:
// - [Gatsby, Gatsby-%23663399, gatsby]
// - [Hugo, Hugo-black, Hugo]
// - [React, react-%2320232a, react, "%2361DAFB"]
// ---
//
// <ListBadges frontmatter={props.pageContext.frontmatter} colLg="3" />
//

const ListBadges = (props) => {
  // Example path:
  // https://img.shields.io/badge/WordPress-%23117AC9.svg?style=for-the-badge&logo=WordPress&logoColor=white
  // Note that logoColor defaults to white if no logoColor is present.
  // https://github.com/Ileriayo/markdown-badges

  return (
    <div class="list-badges">
      {props.frontmatter.badges.map((badge) => (
        <img
          alt={badge[0]}
          src={
            "https://img.shields.io/badge/" +
            badge[1] +
            ".svg?style=for-the-badge&logo=" +
            badge[2] +
            "&logoColor=" +
            (badge[3] ? badge[3] : "white")
          }
        />
      ))}
    </div>
  );
};

export default ListBadges;
